import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/icons/svg/speaker-off.svg'
import _imports_1 from '@/assets/icons/svg/speaker.svg'


const _hoisted_1 = { class: "absolute top-8 left-8 rounded-full bg-white p-4 font-bold text-black text-sm" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex flex-row justify-center" }
const _hoisted_5 = { class: "-mt-10" }
const _hoisted_6 = { class: "inline-block relative" }
const _hoisted_7 = {
  key: 0,
  class: "w-6 h-6",
  src: _imports_0,
  alt: "close"
}
const _hoisted_8 = {
  key: 1,
  class: "w-6 h-6",
  src: _imports_1,
  alt: "close"
}
const _hoisted_9 = { class: "absolute bottom-4 right-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative flex flex-col justify-evenly w-full h-full text-center text-white",
    style: _normalizeStyle({ backgroundColor: $props.playerwordlist.player.profile.avatar.backgroundColour })
  }, [
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("span", null, [
        _createElementVNode("strong", null, _toDisplayString($props.playerwordlist.player.profile.name), 1 /* TEXT */),
        _hoisted_2
      ]),
      _createTextVNode(_toDisplayString($props.description), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode($setup["Avatar"], {
          layout: $props.playerwordlist.player.profile.avatar,
          class: "w-96 h-96"
        }, null, 8 /* PROPS */, ["layout"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("p", {
            class: "p-4 rounded-full bg-white inline-block text-3xl font-bold",
            style: _normalizeStyle({ color: $props.playerwordlist.player.profile.avatar.backgroundColour })
          }, _toDisplayString($props.playerwordlist.wordlist.word), 5 /* TEXT, STYLE */),
          _createVNode($setup["Button"], {
            class: "absolute pointer-events-auto bg-white p-2 rounded-full -top-6 -right-4",
            childclass: 'w-12 h-12',
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.soundIsPlaying ? $setup.stopSounds() : _ctx.$emit('playwordagain')))
          }, {
            default: _withCtx(() => [
              ($setup.soundIsPlaying)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8))
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ]),
    _createCommentVNode(" Get started button goes here"),
    _createElementVNode("div", _hoisted_9, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 4 /* STYLE */))
}